import React from 'react';
import { useAuth } from '../../contexts/AuthContext';

const ConditionalRender = ({ condition, children, fallback = null }) => {
  const { isLoggedIn } = useAuth();
  
  // Handle different condition types
  let shouldRender = false;
  
  switch (condition) {
    case 'isLoggedIn':
      shouldRender = isLoggedIn;
      break;
    case 'isNotLoggedIn':
      shouldRender = !isLoggedIn;
      break;
    default:
      if (typeof condition === 'boolean') {
        shouldRender = condition;
      } else if (typeof condition === 'function') {
        shouldRender = condition();
      }
  }

  return shouldRender ? children : fallback;
};

export default ConditionalRender;
